import React from "react"
import { StyledTestimonialSignOff, StyledTestimonialText } from "../Typography"
import { Container } from "react-grid-system"
import { Fade } from "react-reveal"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledSection = styled.section`
  margin-top: 60px;
  overflow-x: hidden;
  overflow-y: hidden;

  ${breakpoint.lg} {
    margin-top: 130px;
  }
`

const StyledTestimonialTextUpperWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`
const StyledTestimonialTextLowerWrapper = styled.div`
  display: flex;
  justify-content: center;
`
const StyledTestimonialSignOffWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 72px;

  ${breakpoint.lg} {
    justify-content: center;
  }
`

const TestimonialSection = () => {
  return (
    <StyledSection>
      <Container fluid xs sm md>
        <Fade ssrReveal>
          <StyledTestimonialTextUpperWrapper>
            <StyledTestimonialText>
              “This inaugural report marks our first year as an impact investor
              focused on Asia. We hope to share our learnings and experience
              through this report and its future editions.
            </StyledTestimonialText>
          </StyledTestimonialTextUpperWrapper>
          <StyledTestimonialTextLowerWrapper>
            <StyledTestimonialText>
              Together with our stakeholders, we are keen to grow our collective
              work through insights from the ground. Let us work towards a
              better and more resilient Asia together.”
            </StyledTestimonialText>
          </StyledTestimonialTextLowerWrapper>
          <StyledTestimonialSignOffWrapper>
            <StyledTestimonialSignOff>
              The ABC World Asia Team
            </StyledTestimonialSignOff>
          </StyledTestimonialSignOffWrapper>
        </Fade>
      </Container>
    </StyledSection>
  )
}

export default TestimonialSection
